import type React from 'react'
import { Link } from 'react-router-dom'

function PlusIcon(): React.ReactElement {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  )
}

export interface StartNewCardProps {
  readonly newPlanHref: string
}

export function StartNewCard({ newPlanHref }: StartNewCardProps): React.ReactElement {
  return (
    <Link
      to={newPlanHref}
      className="flex flex-col items-start justify-center rounded-base border border-dashed border-border bg-surface-elevated p-5 no-underline transition-colors hover:border-primary hover:bg-primary-soft"
      data-testid="start-new-card"
    >
      <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-soft text-primary">
        <PlusIcon />
      </span>
      <h3 className="mt-3 font-serif text-xl text-foreground">Start a new plan</h3>
      <p className="mt-2 text-sm text-muted-foreground">
        Describe what you want to learn — the AI builds the plan with you.
      </p>
    </Link>
  )
}
